import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Neon Gambit',
    description: "Chess that glows in the dark. Play bullet, blitz and rapid on neon boards, solve puzzles, join nightly arenas and review every game the moment it ends.",
    url: getOrigin()
}
